var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgShield = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 54,
  height: 64,
  viewBox: "0 0 54 64",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M53.0224 9.99853C42.1026 9.99853 33.737 6.87871 26.663 0C19.5897 6.87871 11.2245 9.99853 0.305681 9.99853C0.305681 27.9121 -3.40099 53.5732 26.6628 63.9947C56.7289 53.5733 53.0224 27.9123 53.0224 9.99853ZM24.4795 41.5215L15.698 32.7388L19.6298 28.8072L24.4795 33.6579L33.6971 24.4401L37.6287 28.3717L24.4795 41.5215Z",
  fill: "#F26522"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShield, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shield.803d7960.svg";
export { ForwardRef as ReactComponent };